import $ from "jquery"
import './../scss/style.scss';

// svgstore
// window.baseUrl = '/local/dist/';
// var __svg__ = { path: './../svg/**/*.svg', name: 'sprite.svg' };
// require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);
//  import Bootstrap 
require('bootstrap');

import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'
import ScrollToPlugin from 'gsap/src/ScrollToPlugin'
// GSAP config
gsap.config({nullTargetWarn:false});
// GSAP plugins
gsap.registerPlugin(ScrollToPlugin)

import { WCAG } from "rytm-wcag";
import { initCareerForm } from './career/careerform'
import { initFormValidation } from './shared/form-validation'
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { initModal } from './shared/modal';
import { initWarLiveSearch } from './shared/war-live-search'
import { loadingSequence } from "./loading";


$(() => {
  // # on ready
  WCAG.init()
  initCommon()
  initCookies()
  initModal()
  initWarLiveSearch()
  initFormValidation()
  initCareerForm()
  // loading sequence
  loadingSequence()
});

$(window).on( "load", ()=> {
  // # on load
});